export default __webpack_public_path__ + "assets/images/0d34f81b0a512cd96d1bdc7bf2f75373.svg";